module.exports = __webpack_public_path__ + "img/heimweh_char_sheet_lisa.1e1451e6.png";